import { render, staticRenderFns } from "./MagHistoryTable.vue?vue&type=template&id=30b7b30c"
import script from "./MagHistoryTable.vue?vue&type=script&lang=js"
export * from "./MagHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports